import React, { PropsWithChildren } from "react";

interface Props
  extends React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement> {}

const AppContainer = (props: PropsWithChildren<Props>) => {
  return (
    <div {...props} className={[props.className, "AppContainer"].join(" ")}>
      {props.children}
    </div>
  );
};

export default React.memo(AppContainer);
